import { defineComponent as _defineComponent } from 'vue';
import { computed, watch } from "vue";
import { useToolStore } from "@/stores/toolStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolLink',
    props: {
        toolId: null,
        toolVersion: null
    },
    setup(__props) {
        const props = __props;
        const toolStore = useToolStore();
        const toolName = computed(() => {
            if (props.toolId) {
                return toolStore.getToolNameById(props.toolId);
            }
            return "";
        });
        const toolLink = computed(() => {
            return `/root?tool_id=${props.toolId}&tool_version=${props.toolVersion}`;
        });
        watch(props, () => {
            if (props.toolId && !toolStore.getToolForId(props.toolId)) {
                toolStore.fetchToolForId(props.toolId);
            }
        }, { immediate: true });
        return { __sfc: true, toolStore, props, toolName, toolLink };
    }
});
